/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../../components/Navbar";
import BlogsStatisticsDashboard from "../../../components/WebsiteBlogs/Statistics/StatisticsDashboard";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const WebsiteBlogsStatistics = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.websiteBlogs?.hasStatisticsAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <BlogsStatisticsDashboard ROOT_URL={ROOT_URL} BASE_URL={"admin/cp-digest/statistics"} />
    </>
  );
};

export default WebsiteBlogsStatistics;
